const state = {
  options: {
    status: [
      {value: 1, label: '门店更名'},
      {value: 2, label: '店名一致但门店闭店/装修/歇业'},
      {value: 3, label: '该区域/地址没有指定门店'},
    ]
  }
}

const getters = {}
const actions = {}
const mutations = {}

export const marketNg = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/market-ng/market-ng.store.js